export default "__VITE_ASSET__CsgFtSVs__"